<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>
    <!-- 关键词检索  -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="关键词 ">
          <el-input v-model="input" placeholder="  请输入关键词" />
        </el-form-item>
        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
      <span
        class="attention margin-top10 margin-bot10 margin-left20 margin-right20"
        @click="copyDialogVisible = true"
        >新增</span
      >
    </div>
    <el-skeleton
      class="
        width100
        backwhite
        pad-bot20 pad-top20
        margin-auto margin-top15
        border-rd3
        alldigital
      "
      :loading="loading"
      animated
      :throttle="500"
      v-if="total != 0"
    >
      <template slot="template">
        <div class="width98 margin-auto backwhite">
          <el-table :data="pages" class="eltable margin-auto f14">
            <el-table-column
              label="软件名称"
              align="center"
              prop="softwareName"
              v-if="columns[0].visible"
            />
            <el-table-column
              label="登记号"
              align="center"
              prop="flowNumber"
              v-if="columns[1].visible"
            />
            <el-table-column
              label="下证日期"
              align="center"
              prop="finishDate"
              v-if="columns[2].visible"
            />
            <el-table-column
              label="权利人"
              align="center"
              prop="companyName"
              v-if="columns[3].visible"
            />
            <el-table-column
              label="是否发表"
              align="center"
              prop="isPublic"
              v-if="columns[4].visible"
            />
            <el-table-column
              label="增值服务"
              align="center"
              class-name="small-padding fixed-width"
              v-if="columns[5].visible"
            >
              <template slot-scope="scope">
                <span
                  class="f14 cursorpointer bluecolor"
                  @click="todialog(scope.row)"
                >
                  <span @click="centerDialogVisible = true">增值服务</span>
                </span>
                <span
                  class="bluecolor cursorpointer margin-left10"
                  @click="copyremove(scope.row)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div
            class="flex-betweennowrap margin-top20 width98 margin-auto"
            v-if="total != 0"
          >
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <!-- 增值服务 -->
    <el-dialog
      title="增值服务："
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
      :show-close="true"
      width="30%"
      class="dialogadd"
      center
    >
      <el-form class="demo-ruleForm">
        <span class="bluecolor lineheight60">{{ companytitle }}</span>
        <el-form-item label="">
          <p>增值服务</p>
          <el-checkbox
            label="委托出售"
            v-model="sell"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
        </el-form-item>
        <div class="textalign-right">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            class="Submit cursorpointer"
            @click="Submitfrom()"
            >提 交</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- 新增软件 -->
    <el-dialog
      title="新增软著"
      class="dialogadd"
      :visible.sync="copyDialogVisible"
      :close-on-click-modal="false"
      :show-close="true"
      width="30%"
      center
    >
      <el-form class="demo-ruleForm" :model="ruleForm" :rules="rules">
        <span class="bluecolor lineheight50">{{ companytitle }}</span>
        <el-form-item label="" prop="name">
          <p><span class="proname">*</span> <span> 软件名称</span></p>
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="" prop="pipo">
          <p><span class="proname">*</span> <span> 权利人</span></p>
          <el-input v-model="ruleForm.pipo"></el-input>
        </el-form-item>
        <el-form-item label="" prop="water">
          <p><span class="proname">*</span> <span> 登记号</span></p>
          <el-input v-model="ruleForm.water"></el-input>
        </el-form-item>
        <el-form-item label="" class="pad-bot20" prop="date">
          <p><span class="proname">*</span> <span> 下证日期</span></p>
          <el-date-picker
            v-model="ruleForm.date"
            type="date"
            placeholder="请选择下证日期"
            value-format="yyyy-MM-dd"
            :editable="false"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="" prop="rzbq">
          <p><span class="proname">*</span> <span> 软著版权</span></p>
          <el-radio v-model="ruleForm.rzbq" label="1">软著</el-radio>
          <el-radio v-model="ruleForm.rzbq" label="2">版权</el-radio>
        </el-form-item>
        <el-form-item label="" prop="showfalse">
          <p><span class="proname">*</span> <span> 是否发表</span></p>
          <el-radio v-model="ruleForm.showfalse" label="0">否</el-radio>
          <el-radio v-model="ruleForm.showfalse" label="1">是</el-radio>
        </el-form-item>
        <el-form-item label="" prop="mewho">
          <p><span class="proname">*</span> <span> 软件归属</span></p>
          <el-radio label="0" v-model="ruleForm.mewho">个人</el-radio>
          <el-radio label="1" v-model="ruleForm.mewho"
            >公司({{ companytitle }})</el-radio
          >
        </el-form-item>
        <div class="textalign-right">
          <el-button @click="copyDialogVisible = false">取 消</el-button>
          <el-button type="primary" class="cursorpointer" @click="Submit()"
            >提 交</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="open" append-to-body width="40%">
      <el-transfer
        :titles="['全选', '全选']"
        v-model="value"
        :data="columns"
        @change="dataChange"
      ></el-transfer>
    </el-dialog>
  </div>
</template>
<script>
import {
  copyrighttrusteeshipentcopyright,
  copyrighttrusteeshipupdate,
  copyrighttrusteeshipremove,
  copyrighttrusteeshipsave,
} from "@/api/patent/patent.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      pagination: false,
      centerDialogVisible: false,
      copyDialogVisible: false,
      sell: 0,
      allpage: [],
      ruleForm: {
        name: "",
        pipo: "",
        water: "",
        date: "",
        showfalse: "",
        rzbq: "",
        mewho: "",
      },
      serchkey: true,
      input: "",
      companytitle: "",
      rules: {
        name: [{ required: true, message: "请输入软件名称", trigger: "blur" }],
        pipo: [{ required: true, message: "请输入权利人", trigger: "blur" }],
        water: [
          {
            type: "date",
            required: true,
            message: "请输入登记号",
            trigger: "blur",
          },
        ],
        date: [
          {
            type: "date",
            required: true,
            message: "请选择下证时间",
            trigger: "change",
          },
        ],
        rzbq: [
          {
            type: "array",
            required: true,
            message: "请选择软权版著",
            trigger: "change",
          },
        ],
        showfalse: [
          { required: true, message: "请选择是否发表", trigger: "change" },
        ],
        mewho: [
          { required: true, message: "请选择软件归属", trigger: "change" },
        ],
      },
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      columns: [
        { key: 0, label: `软件名称`, visible: true },
        { key: 1, label: `登记号`, visible: true },
        { key: 2, label: `下证日期`, visible: true },
        { key: 3, label: `权利人`, visible: true },
        { key: 4, label: `是否发表`, visible: true },
        { key: 5, label: `增值服务`, visible: true },
      ],
    };
  },
  inject: ["reload"],
  components: {
    callback,
    switchcore,
  },
  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    // input重 置
    resetForm() {
      this.input = null;
      this.thisNum = 1;
      copyrighttrusteeshipentcopyright({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.isPublic == 0) {
              i.isPublic = "否";
            } else {
              i.isPublic = "是";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 关键词检索
    submitForm() {
      copyrighttrusteeshipentcopyright({
        _keywords: this.input,
        page: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.isPublic == 0) {
              i.isPublic = "否";
            } else {
              i.isPublic = "是";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // 添加
    Submit() {
      copyrighttrusteeshipsave({
        DataType: this.ruleForm.mewho,
        companyName: this.ruleForm.pipo,
        flowNumber: this.ruleForm.water,
        softwareName: this.ruleForm.name,
        isPublic: this.ruleForm.showfalse,
        class: this.ruleForm.rzbq,
        finishDate: this.ruleForm.date,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    copyremove(row) {
      this.$confirm("此操作将删除此软著, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          copyrighttrusteeshipremove({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 增值服务
    todialog(row) {
      this.allpage = row;
      this.sell = this.allpage.sell;
    },
    // 增值服务
    Submitfrom() {
      copyrighttrusteeshipupdate({
        id: this.allpage.id,
        companyName: this.allpage.companyName,
        DataType: this.allpage.DataType,
        flowNumber: this.allpage.flowNumber,
        softwareName: this.allpage.softwareName,
        isPublic: this.sell,
        finishDate: this.allpage.finishDate,
        change_service: 1,
        sell: this.sell,
      }).then((res) => {
        if (res.data.code == 200) {
          this.centerDialogVisible = false;
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "success",
          });
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 分页
    currentchange(val) {
      this.thisNum = val;
      copyrighttrusteeshipentcopyright({
        page: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.isPublic == 0) {
              i.isPublic = "否";
            } else {
              i.isPublic = "是";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      copyrighttrusteeshipentcopyright({
        page: 1,
        limit: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.isPublic == 0) {
              i.isPublic = "否";
            } else {
              i.isPublic = "是";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      copyrighttrusteeshipentcopyright({
        page: this.thisNum,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.isPublic == 0) {
              i.isPublic = "否";
            } else {
              i.isPublic = "是";
            }
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    this.companytitle = window.sessionStorage.getItem("companytitle");

    this.$loading.show(); // 显示loading
    copyrighttrusteeshipentcopyright({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        this.pages = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        this.pages.forEach((i) => {
          if (i.isPublic == 0) {
            i.isPublic = "否";
          } else {
            i.isPublic = "是";
          }
        });
      } else {
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}

.dialogadd >>> .el-dialog__title {
  font-size: 16px;
  color: #606266;
}
.dialogadd >>> .el-dialog__header {
  text-align: left !important;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>